import { last } from 'lodash'

import { TreeNode } from './interface'

export const findNode = <T extends TreeNode<T>>(
  data: T[],
  equalityFn: (value: T) => boolean
) => {
  let result: {
    node?: T
    index: number
    parent?: T
    siblings: T[]
  } = { index: -1, siblings: [] }
  const parents: T[] = []
  const find = (array: T[], equalityFn: (value: T) => boolean) => {
    for (let i = 0; i < array.length; i++) {
      const item = array[i]
      if (equalityFn(item)) {
        result = {
          node: item,
          index: i,
          parent: last(parents),
          siblings: array
        }
        break
      }
      // 已经找到值了，跳出父级循环
      if (result.index !== -1) {
        break
      }
      if (item.children) {
        parents.push(item)
        find(item.children, equalityFn)
        parents.pop()
      }
    }
  }
  find(data, equalityFn)
  return result
}
